import Scroll from '../util/Scroll';

export default {
  init() {
    // this.isShown = null
    // this.$shownTarget = null
    // const selectors = [
    //   '.js-show-register',
    //   '.js-show-login',
    // ]
    // selectors.map(selector => {
    //   $(selector).addClass('hidden')
    //   $($(selector).data('target')).hide()
    //   $(selector).on('click', () => {
    //     this.show(selector)
    //   })
    // })
    $('.js-toggle-form').on('click', (e) => {
      let target = $(e.currentTarget).data('target')
      this.show(target)
    })
    this.show('login')

    let countrySelectId = '#my_country_field'
    if ($(countrySelectId).length) {
      $(countrySelectId).val('NZ')
      $(countrySelectId).trigger('change')
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
  show (target) {
    let $wrapper = $('.mobile-form')
    $wrapper.removeClass('show-login show-register')
    $wrapper.addClass(`show-${target}`)

    setTimeout(() => {
      let scroller = new Scroll
      let offsetTop = $(`form.${target}`).offset().top - 160
      scroller.scrollTo(offsetTop)
    }, 10);

    // const $el = $(selector)
    // const $target = $($(selector).data('target'))
    // $('.mobile-form-toggle').removeClass('hidden')
    // if (this.$shownTarget) {
    //   this.$shownTarget.hide()
    // }
    // console.log($el);

    // $el.addClass('hidden')
    // $target.show()
    // this.isShown = selector
    // this.$shownTarget = $target
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/myAccount.js